export const downloadAttachment = ({ url, title }) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = title;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
};
